import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sidebarSpacer: {
    paddingLeft: "17rem",
  },
  container: {
    padding: "2.5rem",
  },
  buttonBar: {
    "& button": {
      marginLeft: theme.spacing(2),
    },
  },
  buttonText: {
    marginLeft: theme.spacing(1),
  },
  spinnerContainer: {
    padding: `${theme.spacing(5)}px 0`,
  },
}));

export default useStyles;
